import useWebSocket from 'react-use-websocket';

export default function useWebSocketListener(url: string | null, useHook: Function, args: Object | undefined[] = []) {
  const { sendMessage, lastMessage, readyState } = useWebSocket(url, {shouldReconnect: () => true});
  const hookArgs = args ? args : [];
  useHook(lastMessage, hookArgs);
}